import {
  RESET_MESSAGES,
  RESET_BUTTONS,
  SET_BUTTONS,
  SET_MESSAGES,
  SET_MESSAGES_LOADING,
  SET_NEW_MESSAGE,
  SET_TYPING,
  SET_OUTCOMING_LAST,
  SAVE_FEEDBACK,
  SET_IMAGE_PREVIEW,
  REMOVE_IMAGE_PREVIEW,
  SAVE_FETCHED_MESSAGES
} from '../actions/messages';

import { decodeString } from '../../utils';
import { usersRoles } from '../../constants';
import { SET_CAR_BRAND } from '../actions/meta';
import { SET_EXPERTS } from '../actions/experts';

const BUTTONS_LIMIT = 3; // Current limit for displayed buttons with quick answers

export const messagesInitialState = {
  items: [],
  savedItems: [],
  buttons: [],
  hints: null,
  imagePreview: null,
  selectedMessageId: null,
  isTyping: false,
  isOutcomingLast: false,
  isLoading: false,
  hasHistory: false,
};

const messageReducer = (state = messagesInitialState, { type, payload, result }) => {
  switch (type) {
    case SET_MESSAGES: {
      // TODO Подумать, как правильно сделать проверку, чтобы не затиралось первое сообщение
      if (state.items && state.items.length > 0 && result && result.data && result.data.messages && result.data.messages.length === 0) {
        return { ...state, isLoading: false };
      }
      const items =
        result &&
        result.data &&
        result.data.messages &&
        result.data.messages.map((item) => ({
          ...item,
          timestamp: parseInt(item.timestamp, 10),
          content: {
            ...item.content,
            text: decodeString(item.content.text),
          },
        }));

      return {
        ...state,
        items: items || state.items,
        isLoading: false,
        hasHistory: items ? items.length > 0 : state.hasHistory,
      };
    }

    case SET_NEW_MESSAGE: {
      const message =
        result.message_id || result.message_uuid
          ? result
          : result.data && result.data.message
            ? result.data.message
            : {};
      const prevMessages = state.items || [];
      const newMessage = {
        ...message,
        timestamp: parseInt(message.timestamp, 10),
        content: {
          ...message.content,
          text: message.content && decodeString(message.content.text),
        },
      };
      const hasPrevMessages = prevMessages.length > 0;

      let items = prevMessages;
      if (newMessage.message_uuid && hasPrevMessages) {
        items = [...prevMessages.filter((item) => item.message_uuid !== newMessage.message_uuid), newMessage];
      } else if (!newMessage.message_uuid && hasPrevMessages) {
        items = [...prevMessages.filter((item) => item.message_id !== newMessage.message_id), newMessage];
      } else if (!hasPrevMessages) {
        items = [newMessage];
      }

      const senderTypeId = message && message.sender && message.sender.type_id;

      return {
        ...state,
        items,
        isLoading: false,
        isOutcomingLast: senderTypeId === usersRoles.BUYER,
      };
    }

    case SET_BUTTONS:
      const buttons = result.buttons || [];
      const displayedButtons = buttons.slice(0, BUTTONS_LIMIT);
      return { ...state, buttons: displayedButtons };

    case RESET_BUTTONS:
      return { ...state, buttons: messagesInitialState.buttons };

    case SET_TYPING:
      return { ...state, isTyping: payload };

    case SET_OUTCOMING_LAST:
      return { ...state, isOutcomingLast: payload };

    case RESET_MESSAGES:
      return {
        ...state,
        items: [],
        selectedMessageId: null,
        isTyping: false,
        isOutcomingLast: false,
      };

    case SAVE_FETCHED_MESSAGES:
      const previoslySavedIndex = state.savedItems.findIndex(item => item.dialogId === payload.dialogId);
      if (previoslySavedIndex !== -1) {
        const replacingItem = { messages: payload.messages, dialogId: payload.dialogId };
        const updatedSavedItems = state.savedItems.splice(previoslySavedIndex, 1, replacingItem);

        return { ...state, savedItems: [...updatedSavedItems] };
      }

      return {
        ...state, savedItems: [
          ...state.savedItems,
          { messages: payload.messages, dialogId: payload.dialogId }
        ]
      };

    case SET_MESSAGES_LOADING:
      return { ...state, isLoading: true };
    case SAVE_FEEDBACK:
      return {
        ...state,
        items: state.items.map((message) =>
          message.content.showRateComment
            ? { ...message, content: { ...message.content, showRateComment: false } }
            : message,
        ),
      };
    case SET_IMAGE_PREVIEW:
      return { ...state, imagePreview: payload };
    case REMOVE_IMAGE_PREVIEW:
      return { ...state, imagePreview: null };
    case SET_CAR_BRAND:
    case SET_EXPERTS:
      return {
        ...state,
        items: state.items.map((message) => {
          if (message.content.type === 'selectCarBrand') {
            return {
              ...message,
              content: {
                ...message.content,
                visible: false,
              },
            };
          } else {
            return message;
          }
        }),
      };
    default:
      return state;
  }
};

export default messageReducer;
